<template>
  <div class="header">
    <div class="header__author-wrapper">
      <Avatar
        :is-owner="isOwner"
        :avatar-src="author ? author.profile_photo_uri : ''"
      />
      <div>
        <div class="header__author">
          {{
            author && author.display_name
              ? author.display_name
              : isOwner
              ? $t("message.questionsAndAnswers.owner")
              : ""
          }}
        </div>
        <div class="header__date">
          {{ $t("message.common.added") }}: {{ date }}
        </div>
      </div>
    </div>
    <div class="header__likes">
      <v-icon>mdi-thumb-up-outline</v-icon>
      <span>{{ likes }}</span>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/QuestionsAndAnswers/QaAvatar.vue";

export default {
  name: "QaListItemHeader",
  components: {
    Avatar
  },
  props: {
    date: {
      type: String,
      required: true
    },
    likes: {
      type: Number,
      required: true
    },
    author: {
      type: [Object, null]
    },
    isOwner: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing * 2;

  &__author-wrapper {
    display: flex;
    align-items: center;
    gap: $spacing * 3;
  }

  &__author_name {
    @include font-size(16px);
    font-weight: 500;
  }

  &__date {
    @include font-size(14px);
    color: $gray-600;
    font-weight: 400;
  }

  &__likes {
    @include font-size(14px);
    display: flex;
    align-items: center;
    gap: $spacing * 0.75;
    padding: 0 $spacing * 3;
  }
}
</style>
